// extracted by mini-css-extract-plugin
export default {"Tile":"Tile_Tile__BOwpk","Title":"Tile_Title__UsxF1","Subtitle":"Tile_Subtitle__n+MXp","Lower":"Tile_Lower__CJZhH","Price":"Tile_Price__aOb0p","Button":"Tile_Button__qGNuV"};